import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const normalizeRole = (roleStr) => {
  if (!roleStr) return "customer";
  const lower = String(roleStr).toLowerCase().trim();
  if (
    [
      "super admin",
      "superadmin",
      "admin",
      "senior partner",
      "partner",
    ].includes(lower)
  )
    return "admin";
  if (["advocate"].includes(lower)) return "advocate";
  if (["lawyer", "agent"].includes(lower)) return "lawyer";
  if (["customer", "client", "user"].includes(lower)) return "customer";
  return lower;
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useAuth();
  const location = useLocation();

  let activeUser = user;
  if (!activeUser) {
    try {
      const raw =
        sessionStorage.getItem("user") ||
        sessionStorage.getItem("legalagent_user") ||
        localStorage.getItem("user") ||
        localStorage.getItem("legalagent_user");
      if (raw) activeUser = typeof raw === "string" ? JSON.parse(raw) : raw;
    } catch (e) {}
  }

  const isAccessingAdmin =
    location.pathname.startsWith("/admin") &&
    location.pathname !== "/admin/login";

  // 1. Unauthenticated check
  if (!activeUser) {
    if (isAccessingAdmin) {
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // 2. Role authorization check if allowedRoles are specified
  if (allowedRoles && allowedRoles.length > 0) {
    const userRoleRaw = activeUser?.roleType || activeUser?.role || "customer";
    const normalizedUserRole = normalizeRole(userRoleRaw);

    const normalizedAllowedRoles = allowedRoles.map((r) => normalizeRole(r));

    // Also consider 'agent' and 'lawyer' synonyms
    const isAllowed =
      normalizedAllowedRoles.includes(normalizedUserRole) ||
      (normalizedUserRole === "lawyer" &&
        normalizedAllowedRoles.includes("agent")) ||
      (normalizedUserRole === "agent" &&
        normalizedAllowedRoles.includes("lawyer"));

    if (!isAllowed) {
      // Redirect to the user's appropriate default dashboard
      if (normalizedUserRole === "admin") {
        return <Navigate to="/admin" replace />;
      }
      if (normalizedUserRole === "lawyer" || normalizedUserRole === "agent") {
        return <Navigate to="/agent-dashboard" replace />;
      }
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
